/**
 * Idempotency keys for control commands.
 *
 * Every state-changing POST carries one. The key is generated once per
 * *intent* (when the operator opens the confirmation dialog), not per retry:
 * that is the whole point — a double submit, a flaky network retry or an
 * impatient second click must all collapse into a single venue command.
 */

let fallbackCounter = 0;

export function newIdempotencyKey(): string {
  const cryptoRef: Crypto | undefined = globalThis.crypto;
  if (cryptoRef !== undefined && typeof cryptoRef.randomUUID === 'function') {
    return cryptoRef.randomUUID();
  }
  // jsdom without a WebCrypto polyfill, and very old browsers.
  fallbackCounter += 1;
  const random = Math.floor(Math.random() * 0xffffffff).toString(16);
  return `k-${Date.now().toString(16)}-${fallbackCounter.toString(16)}-${random}`;
}
